export {
  cardFilterStaticFactsQueryFn,
  useCardFilterFactsByGrapheme,
  useCardFilterStaticFactsQueryOptions,
  useGetCardFilterStaticFactsQueryKey,
} from "#use-card-filter-facts";
